import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {property} from 'lit/decorators/property.js';
import {classMap} from 'lit/directives/class-map.js';
import {when} from 'lit/directives/when.js';
import {msg} from '@lit/localize';

@customElement('progress-button')
export class ProgressButton extends LitElement {

	static styles = css`
		:host {
			width: 100%;
		}


		button {
			text-align: left;
			font: var(--font-widget-label);
			color: var(--color-white);
			display: flex;
			position: relative;
			flex-direction: row;
			gap: var(--padding);
			justify-content: space-between;
			padding: var(--very-small-padding);
			margin-bottom: 0;
			border: 1px solid var(--color-white);
			cursor: pointer;
			width: 100%;
			transform-origin: center;
		}
		button .progress {
			z-index: 1;
			position: absolute;
			left: 0;
			top: 0;
			bottom: 0;
			transition: width ease-in-out 0.4s;
			display: block;
			background-color: var(--color-white);

		}
		button .label {
			z-index: 2;
			color: var(--color-black);
		}
		button .icon {
			z-index: 3;
			color: var(--color-black);
			display: inline-block;
			line-height: 0;
		}
		button .percentage {
			z-index: 4;
			color: var(--color-ok);
			display: none;
		}

		button:disabled .progress {
			color: var(--color-grey2);
			background-color: var(--color-grey5);
		}
		button:disabled {
			border-color: var(--color-grey5);
		}
		button:disabled .label {
			color: var(--color-grey3);
			border-color: var(--color-grey5);
		}
		button:disabled .percentage {
			color: var(--color-warn);
			display: initial;
		}
		button:disabled .icon {
			color: var(--color-warn);
			display: none;
		}
	`;

	@property({type: Function})
	action = null;

	@property({type: Object})
	icon = null;

	@property({type: String})
	label = '';

	@property({type: Number})
	percentage = 0;

	@property({type: Boolean})
	disabled = false;

	render() {
		return html`
			<button class="downloadButton" ?disabled=${this.disabled} @click=${this.action}>
				<span class="progress" style="width: ${this.percentage}%"></span>
				${when(this.label !== '', () => html`<span class="label">${this.label}</span>`)}
				<span class="percentage">${this.percentage}% ${msg('selected')}</span>
				${when(this.icon !== null, () => html`<span class="icon state ${classMap({satisfied: !this.disabled})}">${this.icon}</span>`)}
			</button>
		`;
	}
}
